import { ModelConfiguration, ModelItem, ModelMethods } from '@europrocurement/l2d-domain/types';
import { DevisFormalitApi } from '@europrocurement/l2d-domain/openApi/ApiFacturation';
import { DataSourcesThunksType } from '@europrocurement/l2d-redux-utils';
import { quoteIcon } from '@europrocurement/l2d-icons';
import { Devis, DEVIS_SLICE_NAME, DevisFormalitApiObject } from '../slices/devisSlice';

const modelKey = 'quote';
const modelName = 'Quote';
const sliceName = DEVIS_SLICE_NAME;

type ModelStructure = Devis;

const methods: ModelMethods<ModelStructure> = {
    getItemDefaultLabel: (model: ModelStructure) => `Numéro: ${model.numero}`,
    getItemSecondaryLabel: (model: ModelStructure) =>
        `Nombre de lignes: ${model.lignes?.length} - Actif: ${model.actif ? 'Oui' : 'Non'}`,
};

export type QuoteEndpoints = {
    list: InstanceType<typeof DevisFormalitApi>['apiDevisFormaliteGetCollection'];
    read: InstanceType<typeof DevisFormalitApi>['apiDevisFormaliteIdGet'];
};

export type QuoteModel = ModelItem<ModelStructure> & QuoteEndpoints;

export const buildQuoteModel = (
    api: DevisFormalitApi,
    datasourcesThunks: DataSourcesThunksType<DevisFormalitApiObject>,
) => {
    const configuration: ModelConfiguration = {
        key: modelKey,
        name: modelName,
        type: 'Quote',
        selector: () => {
            throw new Error('missing selector for quote');
        },
        sliceName,
        api,
        datasourcesThunks,
        icon: quoteIcon,
        // color: 'blue',
    };
    const endpoints = {
        list: api.apiDevisFormaliteGetCollection.bind(api),
        read: api.apiDevisFormaliteIdGet.bind(api),
    };

    const model: QuoteModel = {
        ...configuration,
        ...methods,
        ...endpoints,
    };

    return model;
};
